import type { ChangeEvent } from "react";
import type { TextFieldProps } from "./types";
import { TextFieldValueInterceptorModifier } from "./helpers";

export const useTextField = ({ inputProps, modifiers, onChange }: TextFieldProps) => {
    return {
        onChange: (event: ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => {
            event.target.value = TextFieldValueInterceptorModifier
                .fromInputProps({
                    ...inputProps,
                    ...modifiers
                })
                .modifyValue(event.target.value);

            onChange?.(event);
        }
    };
};

export default useTextField;
